import React from "react";
import { Radio } from "antd";
import { string, func } from "prop-types";

import { ButtonViewTypes } from "./buttonViewTypes";
import { IconLight } from "../";

const ButtonViews = ({ selectedView, onClick }) => {
  function onChange(event) {
    onClick(event.target.value);
  }

  return (
    <Radio.Group
      onChange={onChange}
      defaultValue={selectedView}
      className={"test-button-views"}
    >
      <Radio.Button value={ButtonViewTypes.Table}>
        <IconLight icon={"table"} /> Table
      </Radio.Button>
      <Radio.Button value={ButtonViewTypes.Chart}>
        <IconLight icon="chart-area" /> Chart
      </Radio.Button>
    </Radio.Group>
  );
};

ButtonViews.propTypes = {
  selectedView: string.isRequired,
  onClick: func.isRequired
};

export default ButtonViews;



// WEBPACK FOOTER //
// ./src/views/components/button_views/ButtonViews.jsx